import type { MUISortOptions } from 'mui-datatables';

type DateRangeType = 'end' | 'start';
const getDate = (date: Date | string, rangeType: DateRangeType) => {
  if (
    (typeof date === 'string' && !date.includes(' - ')) ||
    typeof date !== 'string'
  ) {
    return date;
  }
  if (rangeType === 'start') {
    return date.substring(0, date.indexOf(' - '));
  }
  return date.substring(date.indexOf(' - '));
};

export function sortDates(order: MUISortOptions['direction']) {
  return (
    { data: valueA }: { data: string | Date | null },
    { data: valueB }: { data: string | Date | null }
  ) => {
    let cmprA = valueA;
    let cmprB = valueB;
    const multiplier = order === 'desc' ? -1 : 1;

    if (!cmprA) {
      cmprA = new Date(-8640000000000000);
    }
    if (!cmprB) {
      cmprB = new Date(-8640000000000000);
    }

    if (!(
      cmprA instanceof Date ||
      typeof cmprA === 'number' ||
      typeof cmprA === 'string'
    )) {
      return multiplier * 1;
    }
    if (!(
      cmprB instanceof Date ||
      typeof cmprB === 'number' ||
      typeof cmprB === 'string'
    )) {
      return multiplier * -1;
    }

    // Date ranges
    if (
      (typeof cmprA === 'string' && cmprA.includes(' - ')) ||
      (typeof cmprB === 'string' && cmprB.includes(' - '))
    ) {
      const startDateA = getDate(cmprA, 'start');
      const endDateA = getDate(cmprA, 'end');
      const startDateB = getDate(cmprB, 'start');
      const endDateB = getDate(cmprB, 'end');

      const A = new Date(startDateA).getTime() - new Date(startDateB).getTime();
      const B = new Date(endDateA).getTime() - new Date(endDateB).getTime();
      return (A + B) * multiplier;
    }

    return multiplier * (new Date(cmprA).getTime() - new Date(cmprB).getTime());
  };
}
